// "Pendiente Servicios Académicos" y sus variantes ("Pendiente Academicos", "Pendiente servcions academicos",
// "Pendiente"...) no son datos: el personal los tecleó en ~4,900 fichas con la pantalla vieja de alta para pasar
// los campos obligatorios, y la solicitud de reingreso los cargaba como si fueran de la alumna (Esteban,
// 2026-10-26, solicitud #233). Se tratan como vacíos para que el campo salga como "Falta".
// Misma regla que app/Common/DatoDeRelleno.php del backend; si cambia una, cambia la otra.

// texto: el campo es de palabras (ocupación, escuela), así que ".." o "0000" tampoco cuentan ("#146" sí es dato). En contactos no:
// hay fichas con el teléfono en "parentesco" y "Madre" en "teléfono", y esa regla borraría el número.
export function esRelleno(valor: any, texto: boolean = true): boolean
{
	if(typeof valor !== "string" || valor.trim() === "") return false
	const plano = valor.trim().normalize("NFD").replace(/\p{Mn}+/gu, "").toLowerCase()
	if(/^pendi?ent/u.test(plano)) return true
	return texto && !/[\p{L}1-9]/u.test(plano)
}

export function sinRelleno(valor: any, texto: boolean = true): any
{
	return esRelleno(valor, texto) ? "" : valor
}

// Contactos sin "Pendiente…" (solo esa regla). El renglón que tenía relleno y se queda sin nombre ni teléfono se quita; uno que ya venía en blanco se deja.
export function contactosSinRelleno(contactos: any): any[]
{
	if(!Array.isArray(contactos)) return []
	return contactos.flatMap((c: any) =>
	{
		if(!c || typeof c !== "object") return [c]
		if(!esRelleno(c.name, false) && !esRelleno(c.relation, false) && !esRelleno(c.contactMedia, false)) return [c]
		const limpio = { ...c, name: sinRelleno(c.name || "", false), relation: sinRelleno(c.relation || "", false), contactMedia: sinRelleno(c.contactMedia || "", false) }
		return String(limpio.name).trim() !== "" || String(limpio.contactMedia).trim() !== "" ? [limpio] : []
	})
}

// Los datos del alumno (nombres de studentData) sin relleno en ocupación, escuela y contactos.
export function datosSinRelleno<T extends Record<string, any>>(d: T): T
{
	const out: any = { ...d }
	for(const campo of ["currentOccupation", "lastSchoolName"])
	{
		if(campo in out) out[campo] = sinRelleno(out[campo])
	}
	if(Array.isArray(out.contacts)) out.contacts = contactosSinRelleno(out.contacts)
	return out
}

// La ficha de un alumno, para cargarla en una solicitud. Además: la pantalla vieja de alta dejaba el grado de
// estudios en 0 ("Ninguno") sin preguntar; en una ficha sin ocupación real ese 0 no es dato y sale vacío.
export function fichaSinRelleno<T extends Record<string, any>>(d: T): T
{
	const sinOcupacion = String(d.currentOccupation ?? "").trim() === "" || esRelleno(d.currentOccupation)
	const out: any = datosSinRelleno(d)
	if(sinOcupacion && "academicDegreeId" in out && String(out.academicDegreeId) === "0") out.academicDegreeId = ""
	return out
}
